/**
 * Which conversation to open once the one on screen leaves the list.
 *
 * Finishing the last task of a process ends with "Deine aktuellen Arbeiten in
 * diesem Prozess sind zunächst abgeschlossen"; acknowledging it used to create a
 * brand-new empty conversation, which drops the user out of their work queue.
 * They should land on the row that moves up into the finished one's place —
 * the next item they were going to work on anyway.
 *
 * `ordered` is the sidebar's own visual order (its date sections flattened), so
 * "next" means what the user sees, filters included.
 */
export const pickNextConversation = <T extends { _id?: unknown }>(
    ordered: T[],
    completedConversationId: unknown
): T | null => {
    if (!ordered?.length) return null;

    const completedKey = String(completedConversationId ?? '');
    const remaining = ordered.filter(conversation => String(conversation?._id) !== completedKey);
    if (!remaining.length) return null;

    const completedIndex = ordered.findIndex(conversation => String(conversation?._id) === completedKey);
    // Not in the list (filtered out, already gone): start at the top.
    if (completedIndex < 0) return remaining[0];

    // The row that takes the finished one's place — the one below it, or the new
    // last row when it was at the end.
    return remaining[Math.min(completedIndex, remaining.length - 1)];
};
